import React from 'react'
import PropTypes from 'prop-types'
import InternationalizedFormattedText from '../util/internationalized-formatted-text'
import { makeStyles } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import BackButton from '../buttons/backButton/back-button'

const useStyles = makeStyles((theme) => ({
  headTitle: {
    margin: theme.spacing(4, 0),
  },
  backButtonContainer: {
    marginBottom: theme.spacing(1),
  },
  contentTitle: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
  },
  headTitleDivider: {
    backgroundColor: theme.palette.primary.main,
    marginLeft: 0,
    width: 60,
    overflow: 'hidden',
  },
}))

const HeadTitle = ({ text, goBack }) => {
  const classes = useStyles()

  return (
    <div className={classes.headTitle}>
      {goBack && (
        <div className={classes.backButtonContainer}>
          <BackButton />
        </div>
      )}
      <InternationalizedFormattedText variant='h1' className={classes.contentTitle} id={text} />
      <Divider className={classes.headTitleDivider} />
    </div>
  )
}

HeadTitle.propTypes = {
  text: PropTypes.string.isRequired,
  goBack: PropTypes.bool,
}

HeadTitle.defaultProps = {
  goBack: false,
}

export default HeadTitle
